import { render, staticRenderFns } from "./CheckDelivery.vue?vue&type=template&id=afccd414"
import script from "./CheckDelivery.vue?vue&type=script&lang=ts"
export * from "./CheckDelivery.vue?vue&type=script&lang=ts"
import style0 from "./CheckDelivery.vue?vue&type=style&index=0&id=afccd414&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports